import { render, staticRenderFns } from "./NewPersonEmployment.vue?vue&type=template&id=6c54e44c&scoped=true&"
import script from "./NewPersonEmployment.vue?vue&type=script&lang=js&"
export * from "./NewPersonEmployment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c54e44c",
  null
  
)

export default component.exports